import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Parametro from "./Parametro";

const Index = ({ match, history }) => (
  <div className="content-wrapper">
    <Parametro />
    {/* <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/redefinicao-senha`} />
            <Route path={`${match.url}/redefinicao-senha`} component={Redefinicao} />
        </Switch> */}
  </div>
);

export default Index;
